<app-version-check-bar />
<div class="container-fluid pl-0 pr-0">
  <router-outlet></router-outlet>
</div>



